import { isUnknownZip } from 'site-modules/shared/utils/location';

export const isAddressToVinExcludedState = (location = {}) =>
  ['NY', 'CA'].includes(location.stateCode) || isUnknownZip(location);
